import React from 'react';
import { IconProps, IconWrap } from './IconWrap';

export function IconThreeDots({ width = 12, height = 3, ...props }: IconProps) {
    return (
        <IconWrap
            {...props}
            width={width}
            height={height}
            viewBox="0 0 12 3"
            iconClass="three-dots"
        >
            <path
                d="M0.5 1.50001C0.5 0.906458 0.981165 0.425293 1.57471 0.425293C2.16826 0.425293 2.64943 0.906458 2.64943 1.50001C2.64943 2.09355 2.16826 2.57472 1.57471 2.57472C0.981165 2.57472 0.5 2.09355 0.5 1.50001Z"
                fill="#44527B"
                fillOpacity="0.6"
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4253 1.31035C10.3205 1.31035 10.2356 1.39526 10.2356 1.50001C10.2356 1.60475 10.3205 1.68966 10.4253 1.68966C10.53 1.68966 10.6149 1.60475 10.6149 1.50001C10.6149 1.39526 10.53 1.31035 10.4253 1.31035ZM9.35058 1.50001C9.35058 0.906458 9.83175 0.425293 10.4253 0.425293C11.0188 0.425293 11.5 0.906458 11.5 1.50001C11.5 2.09355 11.0188 2.57472 10.4253 2.57472C9.83175 2.57472 9.35058 2.09355 9.35058 1.50001Z"
                fill="#44527B"
                fillOpacity="0.6"
            />

            <path
                d="M4.92529 1.50001C4.92529 0.906458 5.40646 0.425293 6.00001 0.425293C6.59355 0.425293 7.07472 0.906458 7.07472 1.50001C7.07472 2.09355 6.59355 2.57472 6.00001 2.57472C5.40646 2.57472 4.92529 2.09355 4.92529 1.50001Z"
                fill="#44527B"
                fillOpacity="0.6"
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4263 1.31035C10.3215 1.31035 10.2366 1.39526 10.2366 1.50001C10.2366 1.60475 10.3215 1.68966 10.4263 1.68966C10.531 1.68966 10.6159 1.60475 10.6159 1.50001C10.6159 1.39526 10.531 1.31035 10.4263 1.31035ZM9.35156 1.50001C9.35156 0.906458 9.83273 0.425293 10.4263 0.425293C11.0198 0.425293 11.501 0.906458 11.501 1.50001C11.501 2.09355 11.0198 2.57472 10.4263 2.57472C9.83273 2.57472 9.35156 2.09355 9.35156 1.50001Z"
                fill="#DADCE5"
            />

            <path
                d="M0.5 1.50001C0.5 0.906458 0.981165 0.425293 1.57471 0.425293C2.16826 0.425293 2.64943 0.906458 2.64943 1.50001C2.64943 2.09355 2.16826 2.57472 1.57471 2.57472C0.981165 2.57472 0.5 2.09355 0.5 1.50001Z"
                fill="#44527B"
                fillOpacity="0.6"
            />
        </IconWrap>
    );
}
